import EventEmitter from "./EventEmitter.js";

export default class Sizes extends EventEmitter
{
    constructor()
    {
        super();
        console.log("Created Sizes.");
        this.update();

        window.addEventListener("resize", () =>
        {
            this.update();
            this.trigger('resize');
        })
    }

    update()
    {
        console.log("Sizes.update();")
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);
    }
}